import y from 'y4/Utils';
import _ from 'lodash';

export const productReducer = (state, action) => {
  const { type, payload } = action;
  switch (type) {
    case 'CONFIG':
      return {
        ...state,
        config: payload.config,
        paymentMethod: _.first(payload.config.paymentMethods)
      };
    //--------------------Below for product
    case 'SHOW_PRODUCTS':
      return {
        ...state,
        products: payload.products
      };
    case 'SORT_PRODUCT':
      return {
        ...state,
        products: [...state.products].sort((a, b) => {
          if (payload.sortBy === 'review') {
            if (payload.order === 'asc') {
              return a.reviews.length - b.reviews.length;
            } else {
              return b.reviews.length - a.reviews.length;
            }
          } else {
            if (payload.order === 'asc') {
              return a[payload.sortBy] - b[payload.sortBy];
            } else {
              return b[payload.sortBy] - a[payload.sortBy];
            }
          }
        })
      };
    //--------------------Below for cart
    case 'TOGGLE_CART_MODAL':
      return {
        ...state,
        cartModal: {
          ...state.cartModal,
          show: !state.cartModal.show
        }
      };
    case 'ADD_TO_CART':
      return {
        ...state,
        cartItems: [...state.cartItems, payload.product],
        cartModal: {
          show: true,
          product: payload.product,
          quantity: 1
        }
      };
    case 'UPDATE_CART_ITEM':
      return {
        ...state,
        cartItems: state.cartItems.map(item =>
          item.id === payload.product.id ? payload.product : item
        ),
        cartModal: {
          show: payload.showModal,
          product: payload.product,
          quantity: payload.quantity
        }
      };

    case 'REMOVE_FROM_CART':
      return {
        ...state,
        cartItems: state.cartItems.filter(
          product => product.id !== payload.product.id
        ),
        cartModal: {
          show: true,
          product: payload.product,
          type: 'remove'
        }
      };
    case 'APPLY_PROMO': {
      const rt = payload.rt;
      if (rt.isOk()) {
        y.toastSuccess(rt.data.message);
      } else {
        y.toastError(rt.message);
      }
      return {
        ...state,
        promo: rt.data
      };
    }
    //--------------------Below for favourite
    case 'ADD_TO_FAVOURITES':
      return {
        ...state,
        products: state.products.map(product =>
          product.id === payload.product.id
            ? { ...product, favorite: product.favorite + 1 }
            : product
        ),
        favouriteItems: [...state.favouriteItems, payload.product]
      };
    case 'REMOVE_FROM_FAVOURITES':
      return {
        ...state,
        products: state.products.map(product =>
          product.id === payload.product.id
            ? { ...product, favorite: product.favorite - 1 }
            : product
        ),
        favouriteItems: state.favouriteItems.filter(
          product => product.id !== payload.product.id
        )
      };
    //--------------------Below for address
    case 'INIT_ADDRESSES':
      return {
        ...state,
        addressItems: payload.addresses,
        address: _.first(payload.addresses)
      };
    case 'TOGGLE_ADDRESS_MODAL':
      return {
        ...state,
        addressModal: {
          ...state.addressModal,
          show: !state.addressModal.show,
          type: payload?.type,
          address: payload?.address ?? {
            name: '',
            phone: '',
            address: ''
          }
        }
      };
    case 'ADD_TO_ADDRESS':
      return {
        ...state,
        addressItems: [...state.addressItems, payload.address],
        address: payload.address
      };
    case 'UPDATE_ADDRESS_ITEM':
      return {
        ...state,
        addressItems: state.addressItems.map(item =>
          item.id === payload.address.id ? payload.address : item
        ),
        address: payload.address
      };
    case 'REMOVE_ADDRESS':
      return {
        ...state,
        addressItems: state.addressItems.filter(
          item => item.id != payload.address.id
        )
      };
    case 'ADDRESS_MODAL_CHANGE':
      return {
        ...state,
        addressModal: {
          ...state.addressModal,
          address: {
            ...state.addressModal.address,
            ...payload.address
          }
        },
        address: payload.address
      };
    case 'CHANGE_ADDRESS': {
      return {
        ...state,
        address: payload.address
      };
    }

    //--------------------Below for other

    case 'CHANGE_PAYMENT_METHOD': {
      return {
        ...state,
        paymentMethod: payload.paymentMethod
      };
    }

    case 'CHECKOUT': {
      return {
        ...state,
        cartItems: [],
        promo: null
      };
    }
    case 'RESET':
      return {
        ...state
      };
    default:
      return state;
  }
};
